import {HttpCrudDataSource} from '../../../core/data-source/http-crud.data-source';
import {fromJson, toJson} from '../../../core/data-source/json.mapper';
import {httpService} from '../../../core/services/http.service';
import {VehicleChecksFaultsFormRecord} from './vehicle-checks-faults-form.record';

export class VehicleChecksFaultsReportCrudDataSource<T> extends HttpCrudDataSource<T> {
    protected apiPath: string = '/gt/gt-api/vehicle_checks/fault';

    async getByReference(reference: string): Promise<VehicleChecksFaultsFormRecord> {
        return httpService
            .get('/gt/gt-api/vehicle_checks/fault/' + reference)
            .then((response: any) => fromJson(VehicleChecksFaultsFormRecord, response.data));
    }

    async updateByReference(
        reference: string,
        record: VehicleChecksFaultsFormRecord
    ): Promise<VehicleChecksFaultsFormRecord> {
        return httpService
            .post(`/gt/gt-api/vehicle_checks/fault/${reference}/updateStatus`, {
                status: record.status,
                rectifiedDate: record.rectifiedDate.valueOf(),
                resolutionComment: record.resolutionComment
            })
            .then((response: any) => fromJson(VehicleChecksFaultsFormRecord, response.data));
    }
}
